import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { PdpListVariantsModalComponent } from './pdp-list-variants-modal.component';

export const pdpListVariantsModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.PDP_LIST_VARIANTS]: {
      inlineRoot: true,
      component: PdpListVariantsModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
